import htmlTemplate from './search-form.directive.html';

(function () {
	"use strict";

	angular.module("cardspotWeb.areas.fulfillment")
        .directive("emlHvtSearchForm", configDirective);

	function configDirective() {
		return {
			restrict: "E",
			scope: {
				search: "=",
				onSearchClick: "=",
				dateFormat: "="
			},
			controller: SearchFormController,
			controllerAs: "model",
			template: htmlTemplate
		};
	}

	SearchFormController.$inject = ["$scope", "$rootScope"];

	function SearchFormController($scope, $rootScope) {
		var model = this;
		model.resetSearchForm = resetSearchForm;
        model.altDateInputFormats = $rootScope.altDateInputFormats;


		$scope.beginDatePopup = {
			opened: false
		};

		$scope.openBeginDatePicker = function () {
			$scope.beginDatePopup.opened = true;
		};

		$scope.endDatePopup = {
			opened: false
		};

		$scope.openEndDatePicker = function () {
			$scope.beginDatePopup.opened = false;
			$scope.endDatePopup.opened = true;
		};

		function resetSearchForm() {
			$scope.search.filterText = null;
			$scope.search.approvalBeginDate = null;
			$scope.search.approvalEndDate = null;
			$scope.searchForm.$setPristine();
			$scope.onSearchClick();
		}
	}
}());
